import { render } from "./MedalVue.vue?vue&type=template&id=531c8016"
import script from "./MedalVue.vue?vue&type=script&lang=js"
export * from "./MedalVue.vue?vue&type=script&lang=js"

import "./MedalVue.vue?vue&type=style&index=0&id=531c8016&lang=css"

import exportComponent from "/home/runner/work/night.nana7mi.link/night.nana7mi.link/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__